export function getTextFromReactNode(node: React.ReactNode): string {
  if (node === null || node === undefined || typeof node === 'boolean') {
    return ''
  }

  if (typeof node === 'string' || typeof node === 'number') {
    return String(node)
  }

  if ('props' in node) {
    if (node.props.children) {
      if (Array.isArray(node.props.children)) {
        return node.props.children
          .map((child: React.ReactNode) => getTextFromReactNode(child))
          .join('')
      }

      return getTextFromReactNode(node.props.children)
    }
  }

  return ''
}
